import { SmartFilter } from './Smart-Filter';
import { FilterSort } from './Filter-Sort';
import { FilterPagination } from './Filter-Pagination';

export default function initCatalogFilter() {
    const filterElement = document.getElementById('smartfilter');
    const filterSortElement = document.querySelector('.filter-sort');
    const filterPaginationElement = document.getElementById('pagination');

    /* eslint-disable */
    const smartFilter = new SmartFilter(filterElement);
    const filterSort = new FilterSort(filterSortElement);
    const filterPagination = new FilterPagination(filterPaginationElement);

    /* ******** */
    /* ******** */
}
